module.exports = {
    name: "CEAModel",
    //inputs: {
    patientBaseline: {
        label: "Patient baseline characteristics",
        characteristics: [
            ["Characteristics","Mean"],
            ["Age",40],
            ["Gender (% Male)",0.37]
        ]
    },
    transitionProbability: {
        label:"Transition probability",
        labels:["Remission -> recurrence","Recurrence -> remission"],
        remissionRecurrence: [
            ["Time","DX","PLB"],
            ["Month 0 - month 6",0.213,0.365],
            ["Month 6 - month 12",0.066,0.236],
            ["Month 12 - month 18",0.102,0.219],
            ["Month 18 - month 24",0.076,0.0],
            ["Month 24+",0.081,0.152]
        ],
        recurrenceRemission:[
            ["All", 0.824,0.824]
        ]
    },
    mortality:{
        label:"Mortlity",
        labels:["Remission","Relapse"],
        remission:[
            ["Age","Males","Females"],
            [40,0.0011,0.00071],
            [41,0.00113,0.0006],
            [42,0.00128,0.00085],
            [43,0.0015,0.00073],
            [44,0.00151,0.00115],
            [45,0.00199,0.00116],
            [46,0.00197,0.00127],
            [47,0.00204,0.00145],
            [48,0.00212,0.00146],
            [49,0.00261,0.00183],
            [50,0.00322,0.00195]
        ],
        relapse:[
            [40,0.02238,0.014447],
            [41,0.02299,0.012209],
            [42,0.02605,0.017296],
            [43,0.03052,0.014854],
            [44,0.03073,0.0234],
            [45,0.04049,0.023603],
            [46,0.04009,0.025842],
            [47,0.04151,0.029504],
            [48,0.04314,0.029708],
            [49,0.05311,0.037237],
            [50,0.06552,0.039678]
        ]
    },
    cost: {
        label: "Cost (per 6-month cycle) (euros)",
        labels:[
            "Active treatment",
            "Direct medical",
            "Indirect medical"
        ],
        treatmentCost: [
            ["Resource type","Cost"],
            ["DX",273.9],
        ],
        directCost:[
            ["Resource type","Remission","Relapse"],
            ["Outpatient",732,1181],
            ["Other health prof.",420,785],
            ["Hospitalization",149,113],
            ["Antidepressants",209,249],
            ["Other drugs",19,20]
        ],
        indirectCost:[
            ["Resource type","Remission","Relapse"],
            ["Sick leave",3087,5108]
        ]
    },
    QALY:{
        label: "Quality of life input",
        data:[
            ["Health state","Utility","2.5% CI", "97.5% CI"],
            ["Remission",0.81,0.77,0.83],
            ["Relapse",0.57,0.52,0.6]
        ]
    },
    uiLabels:{
        title:"cost-effectiveness analysis",
        effectDiscount: "Effect Discount",
        costDiscount: "Cost Discount",
        timeHorizon: "Time horizon",
        horizons: ["1-year","2-year","5-year","10-year"],
        exclude:"Exclude indirect cost",
        totalCosts:"Total costs €",
        treatment:"DX",
        headers:["DX","PLB","Incr."],
        QALY:"QALYs",
        ICER:"ICER €",
        costPerQALY:"Per QALY gained",
        costs:"Costs"
    },
    dxData: [
        [0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000],//0
        [0.50000000,273.87898130,779.66212970,458.78277933,145.13417053,213.21535329,19.10244121,1615.89687405,3293.53747569,5183.31333104,0.49989319,0.39213348],//1
        [1.00000000,547.40186847,1578.02551290,932.99569334,288.49892982,427.90983050,38.22395425,3265.65392081,6671.92718898,10484.98297827,0.99913642,0.77848809],//2
        [1.50000000,820.48005321,2351.51642560,1387.27351890,433.52075958,640.15507535,57.26187454,4869.72765397,9938.24032072,15628.44802790,1.49756797,1.17051507],//3
        [2.00000000,1093.22992369,3123.61433459,1840.62875159,578.40536073,852.10389137,76.27587476,6471.02821304,13198.53290066,20762.79103738,1.99540027,1.56219449],//4
        [2.50000000,1365.61523004,3890.36890722,2289.87326141,723.44198029,1063.38532846,95.25485833,8062.32433571,16434.97548275,25862.91504850,2.49256715,1.95450262],//5
        [3.00000000,1637.62975419,4656.78837396,2739.08230059,868.22435312,1274.44229028,114.20958517,9652.74690312,19670.21632332,30960.59298063,2.98905727,2.34608734],//6
        [3.50000000,1909.26867756,5422.20838385,3187.71888580,1012.80209239,1485.21306268,133.13827011,11241.08069482,22901.25585858,36051.60523097,3.48486183,2.73711564],//7
        [4.00000000,2180.51484743,6186.50112431,3635.69007713,1157.17244125,1695.67725585,152.03954088,12827.08043942,26127.53072237,41135.12600922,3.97994953,3.12758406],//8
        [4.50000000,2451.31913182,6949.49877635,4082.89084865,1301.31160486,1905.79413018,170.90990839,14410.40526842,29348.32369692,46210.04809716,4.47423068,3.51742973],//9
        [5.00000000,2721.63802622,7711.08417580,4529.25375641,1445.19599354,2115.53041259,189.74635317,15990.81069150,32563.14182738,51275.59054510,4.96762587,3.90658857],//10
        [5.50000000,2991.43870325,8471.17261340,4974.73091665,1588.80751048,2324.86132568,208.54660506,17568.11897126,35771.62987030,56331.18754481,5.46007521,4.29501125],//11
        [6.00000000,3260.69596088,9229.70501899,5419.29041516,1732.13178448,2533.76837865,227.30893449,19142.20453177,38973.54205682,61376.44254948,5.95153267,4.68265829],//12
        [6.50000000,3529.39970021,9986.66446020,5862.92494087,1875.16251647,2742.24476217,246.03266341,20713.02934313,42168.81036689,66411.23941023,6.44197983,5.06951209],//13
        [7.00000000,3797.53504467,10742.00290366,6305.60495328,2017.89227876,2950.27838849,264.71674156,22280.49526575,45357.23020544,71435.26051586,6.93138954,5.45555285],//14
        [7.50000000,4065.07779965,11495.64502306,6747.28467948,2160.30876733,3157.84984739,283.35946705,23844.44778430,48538.48145561,76448.00703956,7.41971764,5.84074766],//15
        [8.00000000,4332.01029519,12247.54996044,7187.94219707,2302.40186129,3364.94622407,301.95962846,25404.79987133,51712.39432397,81449.20449049,7.90693186,6.22506870],//16
        [8.50000000,4598.32754132,12997.71330884,7627.57711229,2444.16813077,3571.56450674,320.51689960,26961.53995824,54878.95310258,86438.82060214,8.39302312,6.60850620],//17
        [9.00000000,4864.00151775,13746.02259005,8066.11589560,2585.59534998,3777.67996734,339.02925324,28514.44305620,58037.67293795,91416.11751190,8.87794026,6.99102879],//18
        [9.50000000,5128.95880197,14492.23565166,8503.40861660,2726.64726774,3983.23249418,357.49149453,30063.01552471,61187.52106561,96379.49539229,9.36154926,7.37254019],//19
        [10.00000000,5393.13376851,15236.17543444,8939.35327770,2867.28832526,4188.17186712,375.89906797,31606.88797249,64327.75242880,101327.77416980,9.84373036,7.75294385]//20
    ],
    plbData:[
        [0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000,0.00000000],//21
        [0.50000000,0.00000000,813.78612970,486.52277933,142.39817053,216.25535329,19.17844121,1678.14087405,3447.81747569,5125.95834974,0.49989319,0.38301348],//22
        [1.00000000,0.00000000,1673.48929988,1010.71073027,280.71330863,436.32335301,38.42557002,3439.66226181,7103.68064302,10543.34290483,0.99881983,0.75259406],//24
        [1.50000000,0.00000000,2495.70789614,1504.90525898,421.46624943,652.65897935,57.54174082,5132.28012473,10590.70280706,15722.98293179,1.49637990,1.13055118],//25
        [2.00000000,0.00000000,3276.85283117,1966.06980505,565.08585877,865.04017784,76.53076063,6749.57943347,13892.49986993,20642.07930340,1.99291311,1.51825213],//26
        [2.50000000,0.00000000,4044.33678703,2416.38470151,709.49752942,1075.99441555,95.46399339,8341.67742691,17132.87148358,25474.54891050,2.48871626,1.90872712],//27
        [3.00000000,0.00000000,4837.22022754,2887.59440236,851.57953068,1289.00843542,114.42927530,9979.83187130,20488.40496215,30468.23683345,2.98381359,2.29156594],//28
        [3.50000000,0.00000000,5628.90717210,3358.18059990,993.34322537,1501.62907662,133.35724844,11615.41732243,23838.99059668,35454.40791911,3.47791367,2.67352658],//29
        [4.00000000,0.00000000,6418.92713511,3827.77226436,1134.81276790,1713.80503146,152.24573022,13247.56292906,27182.51637025,40430.07929931,3.97098383,3.05469552],//30
        [4.50000000,0.00000000,7207.01061413,4296.19596176,1275.95560703,1925.47479509,171.08959091,14875.72656892,30517.82418477,45393.55075369,4.46289369,3.43498818],//31
        [5.00000000,0.00000000,7992.97130909,4763.34227781,1416.73681178,2136.58724585,189.88424496,16499.52188948,33844.12733031,50343.64921979,4.95352319,3.81431012],//32
        [5.50000000,0.00000000,8776.68887119,5229.14355955,1557.13022433,2347.10687219,208.62642971,18118.69595697,37160.92160090,55279.61755787,5.44278613,4.19258996],//33
        [6.00000000,0.00000000,9558.05612488,5693.53829726,1697.11404740,2557.00308625,227.31336480,19733.02492057,40467.75631152,60200.78123209,5.93060935,4.56976844],//34
        [6.50000000,0.00000000,10337.05784627,6156.52299317,1836.67896849,2766.26723949,245.94413543,21342.47118284,43764.57437255,65107.04555539,6.41696749,4.94581919],//35
        [7.00000000,0.00000000,11113.63465216,6618.06110639,1975.81582880,2974.88440450,264.51744517,22946.91343702,47051.12281815,69998.03625517,6.90182704,5.32071780],//36
        [7.50000000,0.00000000,11887.67018596,7078.08002034,2114.50788981,3182.82616818,283.03085474,24546.11511904,50326.90463646,74873.01975550,7.38512525,5.69442000],//37
        [8.00000000,0.00000000,12659.09020127,7536.53736467,2252.73976555,3390.07114278,301.48241418,26139.92088844,53591.60793164,79731.52882008,7.86681073,6.06688392],//38
        [8.50000000,0.00000000,13427.89783069,7993.43967019,2390.50647784,3596.61633475,319.87173510,27728.33204857,56845.25213535,84573.58418392,8.34687211,6.43809504],//39
        [9.00000000,0.00000000,14193.98386870,8448.71569774,2527.79597751,3802.43761154,338.19683432,29311.12998982,60087.36670109,89398.49669091,8.82525931,6.80802238],//40
        [9.50000000,0.00000000,14956.96274080,8902.11941414,2664.55920575,4007.44525623,356.45016470,30887.53678163,63316.29752249,94203.83430412,9.30177979,7.17653772],//41
        [10.00000000,0.00000000,15716.55891444,9353.48898375,2800.74451841,4211.56367361,374.62494584,32456.98103606,66530.88105786,98987.86209392,9.77625604,7.54350145]//42
    ],
    timeHorizon: 2,
    costDiscount: 15/1000,
    effectDiscount:45/1000,
    dataModel:null,
    model:
    {
        dx:null,//[this.dataModel[this.timeHorizon][1][0],this.dataModel[this.timeHorizon][1][1],(this.dataModel[this.timeHorizon][1][0]-this.dataModel[this.timeHorizon][1][1])],
        outpatient:null,//[this.dataModel[this.timeHorizon][2][0],this.dataModel[this.timeHorizon][2][1],(this.dataModel[this.timeHorizon][2][0]-this.dataModel[this.timeHorizon][2][1])],
        other:null,//[this.dataModel[this.timeHorizon][3][0],this.dataModel[this.timeHorizon][3][1],(this.dataModel[this.timeHorizon][3][0]-this.dataModel[this.timeHorizon][3][1])],
        hospitalization:null,//[this.dataModel[this.timeHorizon][4][0],this.dataModel[this.timeHorizon][4][1],(this.dataModel[this.timeHorizon][4][0]-this.dataModel[this.timeHorizon][4][1])],
        antidepressant:null,//[this.dataModel[this.timeHorizon][5][0],this.dataModel[this.timeHorizon][5][1],(this.dataModel[this.timeHorizon][5][0]-this.dataModel[this.timeHorizon][5][1])],
        otherDrugs:null,//[this.dataModel[this.timeHorizon][6][0],this.dataModel[this.timeHorizon][6][1],(this.dataModel[this.timeHorizon][6][0]-this.dataModel[this.timeHorizon][6][1])],
        totalCare:null,//[this.dataModel[this.timeHorizon][7][0],this.dataModel[this.timeHorizon][7][1],(this.dataModel[this.timeHorizon][7][0]-this.dataModel[this.timeHorizon][7][1])],
        leave:null,//[this.dataModel[this.timeHorizon][8][0],this.dataModel[this.timeHorizon][8][1],(this.dataModel[this.timeHorizon][8][0]-this.dataModel[this.timeHorizon][8][1])],
        totalCosts:null,//[this.dataModel[this.timeHorizon][9][0],this.dataModel[this.timeHorizon][9][1],(this.dataModel[this.timeHorizon][9][0]-this.dataModel[this.timeHorizon][9][1])],
        lifeYears:null,//[this.dataModel[this.timeHorizon][10][0],this.dataModel[this.timeHorizon][10][1],(this.dataModel[this.timeHorizon][10][0]-this.dataModel[this.timeHorizon][10][1])],
        QALY:null,//[this.dataModel[this.timeHorizon][11][0],this.dataModel[this.timeHorizon][11][1],(this.dataModel[this.timeHorizon][11][0]-this.dataModel[this.timeHorizon][11][1])],
        ICER:null
    
    // { .dx, .outpatient, .other, .hospitalization, .antidepressant, .otherDrugs, .totalCare, .leave, .totalCosts, .lifeYears, .QALY, .ICER
    //     dx:[this.dataModel[this.timeHorizon][1][0],this.dataModel[this.timeHorizon][1][1],(this.dataModel[this.timeHorizon][1][0]-this.dataModel[this.timeHorizon][1][1])],
    //     outpatient:[this.dataModel[this.timeHorizon][2][0],this.dataModel[this.timeHorizon][2][1],(this.dataModel[this.timeHorizon][2][0]-this.dataModel[this.timeHorizon][2][1])],
    //     other:[this.dataModel[this.timeHorizon][3][0],this.dataModel[this.timeHorizon][3][1],(this.dataModel[this.timeHorizon][3][0]-this.dataModel[this.timeHorizon][3][1])],
    //     hospitalization:[this.dataModel[this.timeHorizon][4][0],this.dataModel[this.timeHorizon][4][1],(this.dataModel[this.timeHorizon][4][0]-this.dataModel[this.timeHorizon][4][1])],
    //     antidepressant:[this.dataModel[this.timeHorizon][5][0],this.dataModel[this.timeHorizon][5][1],(this.dataModel[this.timeHorizon][5][0]-this.dataModel[this.timeHorizon][5][1])],
    //     otherDrugs:[this.dataModel[this.timeHorizon][6][0],this.dataModel[this.timeHorizon][6][1],(this.dataModel[this.timeHorizon][6][0]-this.dataModel[this.timeHorizon][6][1])],
    //     totalCare:[this.dataModel[this.timeHorizon][7][0],this.dataModel[this.timeHorizon][7][1],(this.dataModel[this.timeHorizon][7][0]-this.dataModel[this.timeHorizon][7][1])],
    //     leave:[this.dataModel[this.timeHorizon][8][0],this.dataModel[this.timeHorizon][8][1],(this.dataModel[this.timeHorizon][8][0]-this.dataModel[this.timeHorizon][8][1])],
    //     totalCosts:[this.dataModel[this.timeHorizon][9][0],this.dataModel[this.timeHorizon][9][1],(this.dataModel[this.timeHorizon][9][0]-this.dataModel[this.timeHorizon][9][1])],
    //     lifeYears:[this.dataModel[this.timeHorizon][10][0],this.dataModel[this.timeHorizon][10][1],(this.dataModel[this.timeHorizon][10][0]-this.dataModel[this.timeHorizon][10][1])],
    //     QALY:[this.dataModel[this.timeHorizon][11][0],this.dataModel[this.timeHorizon][11][1],(this.dataModel[this.timeHorizon][11][0]-this.dataModel[this.timeHorizon][11][1])],
    //     ICER:(this.model.totalCosts[2]/this.model.QALY[2]),
    //}
    },
    updateModel: function(excludeIndirect){
        var discountValue;
        for (var x=1; x<21;x++){
            for (var y=1; y<10;y++){
                discountValue = this.getDiscountValue(this.costDiscount,this.dxData[x][0]);
                this.dataModel[x][y][0]=this.dataModel[x-1][y][0]+((this.dxData[x][y]-this.dxData[x-1][y])*discountValue);
                this.dataModel[x][y][1]=this.dataModel[x-1][y][1]+((this.plbData[x][y]-this.plbData[x-1][y])*discountValue);
            }
            for (y=10; y<12;y++){
                discountValue = this.getDiscountValue(this.effectDiscount,this.dxData[x][0]);
                this.dataModel[x][y][0]=this.dataModel[x-1][y][0]+((this.dxData[x][y]-this.dxData[x-1][y])*discountValue);
                this.dataModel[x][y][1]=this.dataModel[x-1][y][1]+((this.plbData[x][y]-this.plbData[x-1][y])*discountValue);
            }
        }
        this.model.dx =[this.dataModel[this.timeHorizon][1][0],this.dataModel[this.timeHorizon][1][1],(this.dataModel[this.timeHorizon][1][0]-this.dataModel[this.timeHorizon][1][1])];
        this.model.outpatient=[this.dataModel[this.timeHorizon][2][0],this.dataModel[this.timeHorizon][2][1],(this.dataModel[this.timeHorizon][2][0]-this.dataModel[this.timeHorizon][2][1])];
        this.model.other=[this.dataModel[this.timeHorizon][3][0],this.dataModel[this.timeHorizon][3][1],(this.dataModel[this.timeHorizon][3][0]-this.dataModel[this.timeHorizon][3][1])];
        this.model.hospitalization=[this.dataModel[this.timeHorizon][4][0],this.dataModel[this.timeHorizon][4][1],(this.dataModel[this.timeHorizon][4][0]-this.dataModel[this.timeHorizon][4][1])];
        this.model.antidepressant=[this.dataModel[this.timeHorizon][5][0],this.dataModel[this.timeHorizon][5][1],(this.dataModel[this.timeHorizon][5][0]-this.dataModel[this.timeHorizon][5][1])];
        this.model.otherDrugs=[this.dataModel[this.timeHorizon][6][0],this.dataModel[this.timeHorizon][6][1],(this.dataModel[this.timeHorizon][6][0]-this.dataModel[this.timeHorizon][6][1])];
        this.model.totalCare=[this.dataModel[this.timeHorizon][7][0],this.dataModel[this.timeHorizon][7][1],(this.dataModel[this.timeHorizon][7][0]-this.dataModel[this.timeHorizon][7][1])];
        this.model.leave=[this.dataModel[this.timeHorizon][8][0],this.dataModel[this.timeHorizon][8][1],(this.dataModel[this.timeHorizon][8][0]-this.dataModel[this.timeHorizon][8][1])];
        this.model.totalCosts=[this.dataModel[this.timeHorizon][9][0],this.dataModel[this.timeHorizon][9][1],(this.dataModel[this.timeHorizon][9][0]-this.dataModel[this.timeHorizon][9][1])];
        this.model.lifeYears=[this.dataModel[this.timeHorizon][10][0],this.dataModel[this.timeHorizon][10][1],(this.dataModel[this.timeHorizon][10][0]-this.dataModel[this.timeHorizon][10][1])];
        this.model.QALY=[this.dataModel[this.timeHorizon][11][0],this.dataModel[this.timeHorizon][11][1],(this.dataModel[this.timeHorizon][11][0]-this.dataModel[this.timeHorizon][11][1])];
        this.model.ICER = this.model.totalCosts[2]/this.model.QALY[2];
        if (!excludeIndirect){
            this.model.totalCosts[0]=this.model.totalCosts[0]-this.model.leave[0];
            this.model.totalCosts[1]=this.model.totalCosts[1]-this.model.leave[1];
            this.model.totalCosts[2]=this.model.totalCosts[2]-this.model.leave[2];
            this.model.leave[2]=0.0;
            this.model.leave[0]=0.0;
            this.model.leave[1]=0.0;
        }
        this.model.lifeYears[2]=this.model.lifeYears[0]-this.model.lifeYears[1];
        this.model.QALY[2]=this.model.QALY[0]-this.model.QALY[1];
        this.model.ICER = this.model.totalCosts[2]/this.model.QALY[2];
    },
    createModel:function(){
        var discountValue,diff,computedValue,diff2,computedValue2,temp;
        var computedData = [[[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0],[0.0,0.0]]];
        for (var x=1; x<21;x++){
            temp = [this.dxData[x][0]];
            for (var y=1; y<12;y++){
                if(y>9){
                    discountValue = this.getDiscountValue(this.effectDiscount,this.dxData[x][0]);
                } else {
                    discountValue = this.getDiscountValue(this.costDiscount,this.dxData[x][0]);
                }
                diff = this.dxData[x][y]-this.dxData[x-1][y];
                computedValue = computedData[x-1][y][0]+((diff)*discountValue);
                diff2 = this.plbData[x][y]-this.plbData[x-1][y];
                computedValue2 = computedData[x-1][y][1]+((diff2)*discountValue);
                temp.push([computedValue,computedValue2]);
            }
            computedData.push(temp);
        }
        return computedData;
    },
    formatThousands: function(value, places){
        var returnValue = value.toLocaleString(undefined, {minimumFractionDigits: places, maximumFractionDigits: places});
        if ((returnValue.charAt(0)=='-')&&(returnValue.charAt(1)=='0')){
            returnValue='0';
        }
        return returnValue;
    },
    getData:function(){
        return {
            dx:this.formatListValues(this.model.dx,0),
            outpatient:this.formatListValues(this.model.outpatient,0),
            other:this.formatListValues(this.model.other,0),
            hospitalization:this.formatListValues(this.model.hospitalization,0),
            antidepressant:this.formatListValues(this.model.antidepressant,0),
            otherDrugs:this.formatListValues(this.model.otherDrugs,0),
            totalCare:this.formatListValues(this.model.totalCare,0),
            leave:this.formatListValues(this.model.leave,0),
            totalCosts:this.formatListValues(this.model.totalCosts,0),
            lifeYears:this.formatListValues(this.model.lifeYears,0),
            QALY:this.formatListValues(this.model.QALY, 3),
            ICER:this.formatThousands(this.model.ICER,0)
        };
    },
    formatListValues: function(list,places){
        var newList = [];
        for (var x=0; x<list.length; x++) {
            newList.push(this.formatThousands(list[x],places));
        }
        return newList;
    },
    getDiscountValue: function(discountValue,yearValue){
        yearValue = Math.trunc(yearValue);
        return (1.0/Math.pow((1.0+discountValue),yearValue));
    }
}


// WEBPACK FOOTER //
// ./src/assets/models/CEA.js